import React from "react";
import { Link } from "react-router-dom";
import { notfound } from "../assets";

const NotFound = () => {
  return <ContentSection />;
};

export default NotFound;

const ContentSection = () => {
  let imgUrl =
    "https://cdn.discordapp.com/attachments/920721313105080390/1305569818501578752/Group_8.png?ex=67338225&is=673230a5&hm=612b814462bf449f0e0519a5b4eacaa9a9432ed7187030ddcfccfca6159cee9f&";
  return (
    <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12 flex lg:flex-row md:flex-row sm:flex-col justify-center items-center gap-12">
      {/* IMAGE */}
      <div>
        <img
          src={notfound}
          width={300}
          alt=""
          className="lg:block md:hidden sm:hidden"
        />
        <img
          src={notfound}
          width={260}
          alt=""
          className="lg:hidden md:block sm:hidden"
        />
        <img
          src={notfound}
          width={200}
          alt=""
          className="lg:hidden md:hidden sm:block"
        />
      </div>
      {/* CONTENT */}
      <div className="flex flex-col lg:items-start md:items-start sm:items-center">
        <h2 className="g:text-3xl md:text-2xl sm:text-xl mb-2">
          Oops! You’ve Time-Traveled to Nowhere ⏳
        </h2>
        <p className="mb-8 lg:text-left md:text-left sm:text-center max-w-[520px]">
          Looks like this page has vanished into the abyss—probably off enjoying
          a luxury vacation with a Rolex on its wrist. But don’t worry, we’ve
          got plenty of real luxury watches waiting for you. No missing pages,
          just timeless timepieces.
        </p>
        <p className="mb-4 underline hover:text-[#3367D1]">
          <a href="/explore-brands">Find your next luxury watch here!</a>
        </p>
        {/* CTA */}
        <Link to={"/"} className="px-8 py-3 rounded-lg border border-black">
          Go to Home
        </Link>
      </div>
    </section>
  );
};
